import axios from '@hw-core/libs/axios'
import store from '@/shared/store'
import { auth, db, functions } from '@/shared/services/firebase'

async function saveMessageToDB({ smsId, dataToUpdate }) {
  let id = smsId
  if (smsId) {
    await db.collection('messages').doc(id)
      .update({
        ...dataToUpdate,
        published: new Date(),
      })
  } else {
    const doc = await db.collection('messages').add({
      ...dataToUpdate,
      published: new Date(),
    })
    id = doc.id
  }
  return id
}
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    postMessage(ctx, message) {
      return new Promise((resolve, reject) => {
        db.collection('messages').add({
          ...message,
          to: 'all',
          published: true,
          date: new Date(),
        })
          .then(() => resolve())
          .catch(e => reject(e))
      })
    },
    async fetchEmails(ctx, queryParams) {
      const DEFAULT_LIMIT = 10
      let { list } = queryParams
      let query = db.collection('messages')
        .where('category', '==', 'announcement')
        .orderBy('published', 'desc')

      if (list && list.length >= DEFAULT_LIMIT) {
        query = query.startAfter(list[queryParams.list.length - 1].published)
      } else {
        list = []
      }
      try {
        const snapshot = await query.limit(DEFAULT_LIMIT).get()
        const messages = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
        list.push(...messages)
        return { data: list, isMore: messages.length >= DEFAULT_LIMIT }
      } catch (error) {
        throw new Error('Error fetching messages', error)
      }
    },
    fetchSmses(ctx, { list, callback }) {
      const DEFAULT_LIMIT = 10
      let query = db.collection('messages')
        .where('category', '==', 'sms')
        .orderBy('published', 'desc')

      if (list.length >= DEFAULT_LIMIT) {
        query = query.startAfter(list[list.length - 1].published)
      }

      query.limit(DEFAULT_LIMIT)
        .onSnapshot(snapshot => {
          const changes = snapshot.docChanges()
          if (changes.length > 0) {
            changes.forEach(change => {
              const item = change.doc.data()
              item.published = item.published.toDate()
              item.id = change.doc.id
              callback({ type: change.type, data: item, isMore: changes.length >= DEFAULT_LIMIT })
            })
          } else {
            callback({ isMore: changes.length >= DEFAULT_LIMIT })
          }
        })
    },
    updateEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/email/update-emails', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEmailLabels(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/email/update-emails-label', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    paginateEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/email/paginate-email', { params: payload })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    uploadFile(ctx, {
      file,
    }) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          const formData = new FormData()
          formData.append('token', idToken)
          formData.append('file', file)
          axios.post(`${functions.url}/uploadImage`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(res => {
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    postAnnouncement(ctx, form) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          axios
            .post(`${store.state.app.appConfig.type === 'hw-admin' ? functions.url : functions.oiwaUrl}/createAnnouncement`, { data: form, token: idToken })
            .then(response => resolve(response))
            .catch(error => {
              reject(error)
            })
        }).catch(error => {
          reject(error)
        })
      })
    },
    editAnnouncement(ctx, { id, data }) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          axios
            .post(`${functions.url}/updateAnnouncement`, { id, data, token: idToken })
            .then(response => resolve(response))
            .catch(error => reject(error))
        }).catch(error => {
          reject(error)
        })
      })
    },
    deleteAnnouncements(ctx, { ids }) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          axios
            .post(`${store.state.app.appConfig.type === 'hw-admin' ? functions.url : functions.oiwaUrl}/deleteAnnouncements`, { ids, token: idToken })
            .then(response => resolve(response))
            .catch(error => reject(error))
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetchUsers(ctx, {
      state, city, role, status,
    }) {
      return new Promise((resolve, reject) => {
        let query = db.collection('users')

        if (status) {
          query = query.where('status', '==', status)
        }

        if (state) {
          query = query.where('address.state', '==', state)
        }

        if (city && city.length > 0) {
          const cities = city.map(item => item.toLowerCase())
          query = query.where('address.city', 'in', cities)
        }

        if (role) {
          query = query.where('role', '==', role)
        }

        query.get()
          .then(snapshot => {
            const { length } = snapshot.docs
            resolve(length)
          })
          .catch(() => {
            reject()
          })
      })
    },

    async sendSmsFromCsv(ctx, { users, data }) {
      try {
        const id = await saveMessageToDB({ smsId: null, data })
        if (data.status === 'sending') {
          const token = await auth.currentUser.getIdToken(true)
          await axios.post(`${functions.url}/sendSmsFromCsv`, {
            message: data.message,
            token,
            users,
            id,
          })
        }
      } catch (e) {
        console.error(e)
      }
    },

    createUpdateSms(ctx, { smsId, dataToUpdate }) {
      return new Promise((resolve, reject) => {
        saveMessageToDB({ smsId, dataToUpdate }).then(id => {
          if (dataToUpdate.status === 'sending') {
            auth.currentUser.getIdToken(true).then(idToken => {
              axios
                .post(`${functions.url}/sendSmsForTargets`, {
                  token: idToken,
                  target: dataToUpdate.target,
                  message: dataToUpdate.message,
                  id,
                })
                .then(async response => {
                  resolve(response)
                })
                .catch(error => {
                  reject(error)
                })
            })
          }
        }).catch(error => reject(error))
      })
    },
  },
}
